
import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

import {
  FaHome,
  FaFutbol,
  FaGift,
  FaHistory,
  FaMoneyBill,
  FaTradeFederation,
} from "react-icons/fa";

import "./BottomNavigation.css";

const translations = {
  en: {
    home: "Home",
    marketTrade: "MarketTrade",
    offers: "Offers",
    betTrade: "BetTrade",
    history: "History",
    assets: "Assets",
  },

  fr: {
    home: "Accueil",
    marketTrade: "Marché",
    offers: "Offres",
    betTrade: "Paris",
    history: "Historique",
    assets: "Actifs",
  },

  sw: {
    home: "Nyumbani",
    marketTrade: "Soko",
    offers: "Ofa",
    betTrade: "BetTrade",
    history: "Historia",
    assets: "Mali",
  },

  pt: {
    home: "Início",
    marketTrade: "Mercado",
    offers: "Ofertas",
    betTrade: "Apostas",
    history: "Histórico",
    assets: "Ativos",
  },

  es: {
    home: "Inicio",
    marketTrade: "Mercado",
    offers: "Ofertas",
    betTrade: "Apuestas",
    history: "Historial",
    assets: "Activos",
  },


  ar: {
    home: "الرئيسية",
    marketTrade: "السوق",
    offers: "العروض",
    betTrade: "التداول",
    history: "السجل",
    assets: "الأصول",
  },
  
  zh: {
    home: "首页",
    marketTrade: "市场",
    offers: "优惠",
    betTrade: "投注交易",
    history: "历史记录",
    assets: "资产",
  },
  
  hi: {
    home: "होम",
    marketTrade: "बाज़ार",
    offers: "ऑफ़र",
    betTrade: "बेट ट्रेड",
    history: "इतिहास",
    assets: "संपत्तियाँ",
  },
  
  bn: {
    home: "হোম",
    marketTrade: "বাজার",
    offers: "অফার",
    betTrade: "বেট ট্রেড",
    history: "ইতিহাস",
    assets: "সম্পদ",
  },
  
  ru: {
    home: "Главная",
    marketTrade: "Рынок",
    offers: "Предложения",
    betTrade: "Бет-трейдинг",
    history: "История",
    assets: "Активы",
  },
  
  de: {
    home: "Startseite",
    marketTrade: "Markt",
    offers: "Angebote",
    betTrade: "Wett-Handel",
    history: "Verlauf",
    assets: "Vermögen",
  },
  
  it: {
    home: "Home",
    marketTrade: "Mercato",
    offers: "Offerte",
    betTrade: "Bet Trading",
    history: "Cronologia",
    assets: "Patrimonio",
  },
  
  nl: {
    home: "Home",
    marketTrade: "Markt",
    offers: "Aanbiedingen",
    betTrade: "Bet Trading",
    history: "Geschiedenis",
    assets: "Bezittingen",
  },
  


  tr: {
    home: "Ana Sayfa",
    marketTrade: "Piyasa",
    offers: "Teklifler",
    betTrade: "Bahis Ticareti",
    history: "Geçmiş",
    assets: "Varlıklar",
  },
  
  ja: {
    home: "ホーム",
    marketTrade: "マーケット",
    offers: "オファー",
    betTrade: "ベット取引",
    history: "履歴",
    assets: "資産",
  },
  
  ko: {
    home: "홈",
    marketTrade: "마켓",
    offers: "혜택",
    betTrade: "베팅 거래",
    history: "기록",
    assets: "자산",
  },
  
  vi: {
    home: "Trang chủ",
    marketTrade: "Thị trường",
    offers: "Ưu đãi",
    betTrade: "Giao dịch cược",
    history: "Lịch sử",
    assets: "Tài sản",
  },
  
  th: {
    home: "หน้าหลัก",
    marketTrade: "ตลาด",
    offers: "ข้อเสนอ",
    betTrade: "เทรดเดิมพัน",
    history: "ประวัติ",
    assets: "สินทรัพย์",
  },
  
  id: {
    home: "Beranda",
    marketTrade: "Pasar",
    offers: "Penawaran",
    betTrade: "Perdagangan Taruhan",
    history: "Riwayat",
    assets: "Aset",
  },
  
  ms: {
    home: "Laman Utama",
    marketTrade: "Pasaran",
    offers: "Tawaran",
    betTrade: "Dagangan Pertaruhan",
    history: "Sejarah",
    assets: "Aset",
  },
  
  ur: {
    home: "صفحہ اول",
    marketTrade: "مارکیٹ",
    offers: "پیشکشیں",
    betTrade: "بیٹ ٹریڈ",
    history: "تاریخ",
    assets: "اثاثے",
  },
  
  fa: {
    home: "خانه",
    marketTrade: "بازار",
    offers: "پیشنهادها",
    betTrade: "معاملات شرط‌بندی",
    history: "تاریخچه",
    assets: "دارایی‌ها",
  },
  
  ha: {
    home: "Gida",
    marketTrade: "Kasuwa",
    offers: "Kyaututtuka",
    betTrade: "Cinikin Fare",
    history: "Tarihi",
    assets: "Kadarori",
  },
  
  yo: {
    home: "Ilé",
    marketTrade: "Ọjà",
    offers: "Àwọn Ìfilọ́lẹ̀",
    betTrade: "Òwò Tẹtẹ",
    history: "Ìtàn",
    assets: "Àwọn Ohun-ìní",
  },
  
  zu: {
    home: "Ekhaya",
    marketTrade: "Imakethe",
    offers: "Izipesheli",
    betTrade: "Ukuhweba Ngokubheja",
    history: "Umlando",
    assets: "Izimpahla",
  },
  
  am: {
    home: "መነሻ",
    marketTrade: "ገበያ",
    offers: "ቅናሾች",
    betTrade: "የውርርድ ንግድ",
    history: "ታሪክ",
    assets: "ንብረቶች",
  },
  
  so: {
    home: "Bogga Hore",
    marketTrade: "Suuqa",
    offers: "Dalabyo",
    betTrade: "Ganacsiga Sharadka",
    history: "Taariikhda",
    assets: "Hantida",
  },
  
  rw: {
    home: "Ahabanza",
    marketTrade: "Isoko",
    offers: "Ibyifuzo",
    betTrade: "Ubucuruzi bw'Inshuro",
    history: "Amateka",
    assets: "Umutungo",
  },
  
  lg: {
    home: "Awaka",
    marketTrade: "Akataale",
    offers: "Ebiweebwayo",
    betTrade: "Okusuubula ku Bbeetingi",
    history: "Ebyafaayo",
    assets: "Eby'obugagga",
  },
  
  af: {
    home: "Tuis",
    marketTrade: "Mark",
    offers: "Aanbiedinge",
    betTrade: "Wedhandel",
    history: "Geskiedenis",
    assets: "Bates",
  },
  





};

const originalLabels = {
  home: "Home",
  marketTrade: "MarketTrade",
  offers: "Offers",
  betTrade: "BetTrade",
  history: "History",
  assets: "Assets",
};

const BottomNavigation = () => {
  const [language, setLanguage] = useState(() => {
    // Kama user hajachagua lugha, tumia lugha ya mwanzo
    const savedLanguage = localStorage.getItem("language");

    return savedLanguage &&
      translations[savedLanguage]
      ? savedLanguage
      : null;
  });

  useEffect(() => {
    const updateLanguage = () => {
      const savedLanguage = localStorage.getItem("language");

      if (
        savedLanguage &&
        translations[savedLanguage]
      ) {
        setLanguage(savedLanguage);
      } else {
        setLanguage(null);
      }
    };

    // Sikiliza mabadiliko ya lugha ndani ya app
    window.addEventListener(
      "languageChanged",
      updateLanguage
    );

    // Sikiliza mabadiliko kutoka tab nyingine
    window.addEventListener("storage", updateLanguage);

    return () => {
      window.removeEventListener(
        "languageChanged",
        updateLanguage
      );

      window.removeEventListener(
        "storage",
        updateLanguage
      );
    };
  }, []);

  // Tumia tafsiri ikiwa lugha imechaguliwa.
  // Vinginevyo, tumia majina ya mwanzo.
  const t = language
    ? translations[language]
    : originalLabels;

  return (
    <div className="bottom-nav">
      <NavLink
        to="/dashboard"
        className={({ isActive }) =>
          isActive ? "nav-item active-nav" : "nav-item"
        }
      >
        <FaHome />
        <span>{t.home}</span>
      </NavLink>

      <NavLink
        to="/sports"
        className={({ isActive }) =>
          isActive ? "nav-item active-nav" : "nav-item"
        }
      >
        <FaFutbol />
        <span>{t.marketTrade}</span>
      </NavLink>

      <NavLink
        to="/gift"
        className={({ isActive }) =>
          isActive ? "nav-item active-nav" : "nav-item"
        }
      >
        <FaGift />
        <span>{t.offers}</span>
      </NavLink>

      <NavLink
        to="/bet-trade"
        className={({ isActive }) =>
          isActive ? "nav-item active-nav" : "nav-item"
        }
      >
        <FaTradeFederation />
        <span>{t.betTrade}</span>
      </NavLink>

      <NavLink
        to="/history"
        className={({ isActive }) =>
          isActive ? "nav-item active-nav" : "nav-item"
        }
      >
        <FaHistory />
        <span>{t.history}</span>
      </NavLink>

      <NavLink
        to="/assets"
        className={({ isActive }) =>
          isActive ? "nav-item active-nav" : "nav-item"
        }
      >
        <FaMoneyBill />
        <span>{t.assets}</span>
      </NavLink>
    </div>
  );
};

export default BottomNavigation;
